
import _ from 'underscore';
import classNames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@bingads-webui-react/primitive';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';

import { getFooterStyles } from './get-styles';

const StepFooterUnstyled = (props) => {
  const { config, classes } = props;

  const BS_BUTTON = {
    Primary: 'primary',
    'Primary-Start': 'primary',
    Secondary: 'default',
    Cancel: 'default',
    Link: 'link',
    BasicLink: 'basiclink',
  };

  const getClasses = (type) => {
    if (type === 'Primary') {
      return classNames('btn-footer-primary', classes.primary);
    } else if (type === 'Primary-Start') {
      return classNames('btn-footer-primary', classes.start);
    } else if (type === 'Cancel') {
      return classNames('btn-footer-cancel', classes.cancel);
    } else if (type === 'Link') {
      return classNames('btn-footer-link', classes.link);
    } else if (type === 'BasicLink') {
      return classNames('btn-footer-basiclink', classes.basicLink);
    }
    return classNames('btn-footer-secondary', classes.secondary);
  };

  return (
    <div className={classNames('conversion-wizard-footer', classes.footerContainer)}>
      <div className={classNames('step-footer-buttons', classes.footerButtons)}>
        {_.isEmpty(config.buttons) ? null : _.map(config.buttons, ({
          text,
          isEnabled,
          type,
          onClick,
        }) =>
          (
            <React.Fragment
              key={text}
            >
              <Button
                disabled={!isEnabled}
                btnStyle={BS_BUTTON[type]}
                className={getClasses(type)}
                onClick={onClick}
              >
                {text}
              </Button>
            </React.Fragment>
          ))
        }
        {config.customContent}
      </div>
      {config.error &&
        <div className="error">
          {config.error}
        </div>
      }
    </div >
  );
};

export const footerConfigProp = PropTypes.shape({
  error: PropTypes.string,
  buttons: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string.isRequired,
    type: PropTypes.oneOf(['Primary', 'Primary-Start', 'Secondary', 'Cancel', 'Link', 'BasicLink']),
    isEnabled: PropTypes.bool,
    onClick: PropTypes.func,
  })),
});

StepFooterUnstyled.propTypes = {
  config: footerConfigProp.isRequired,
  classes: PropTypes.shape(_.mapObject(getFooterStyles(), _.constant(PropTypes.string.isRequired)))
    .isRequired,
};

export const StepFooter = withDefaultStyles(StepFooterUnstyled, getFooterStyles);
